import { createRef, RefObject, useEffect, useRef, useState } from "react";
import useIntersectionObserver from "./useIntersectionObserver";

const useIncreasingNumber = (ref: RefObject<any>, maxValue: number): string => {
  const { isInView, countRendered } = useIntersectionObserver(ref);
  const [count, setCount] = useState(0);
  const intervalId: any = createRef();

  useEffect(() => {
    if (!ref?.current || !maxValue) return;

    if (!isInView) {
      setCount(0);
      return clearInterval(intervalId?.current);
    }

    intervalId.current = setInterval(() => {
      setCount((prevCount) => {
        const incrementedCount = prevCount + maxValue / 30;
        if (incrementedCount < maxValue) {
          return incrementedCount;
        }
        return maxValue;
      });
    }, 100);

    return () => clearInterval(intervalId.current);
  }, [ref, maxValue, isInView, countRendered]);

  // format to comma separated

  return count.toFixed(0);
};

export default useIncreasingNumber;
